module.exports = __webpack_public_path__ + "static/media/menuimage_places.9d51a9f8.jpg";